import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import ListDepositComponents from "../components";
import { getPatientDeposits } from "../../../../../services/Handlers/PatientDepositService";
import { useAuth } from "../../../../../context/AuthProvider";
import { PER_PAGE_SIZE } from "../../../../../utils/constants";

export default function ListDeposit() {
  const { userDetail } = useAuth();

  const [page, setPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [totalEntries, setTotalEntries] = useState(0);
  const [dataPatientDeposit, setDataPatientDeposit] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(PER_PAGE_SIZE);
  const [filterDeposit, setFilterDeposit] = useState({
    identity_number: "",
    name: "",
    phone_number: "",
    page: 0,
    size: PER_PAGE_SIZE,
  });

  const { isLoading, isFetching, refetch } = useQuery(
    ["PatientDepositList", userDetail?.businessId, page, sizePerPage],
    () =>
      getPatientDeposits({
        businessId: userDetail?.businessId,
        page,
        size: sizePerPage,
        identity_number: filterDeposit.identity_number,
        name: filterDeposit.name,
        phone_number: filterDeposit.phone_number,
      }),
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          setDataPatientDeposit(res?.data?.data || []);
          const total =
            res?.data?.pagination?.total ?? res?.data?.total ?? 0;
          const totalPages =
            res?.data?.pagination?.totalPages ??
            Math.ceil(total / sizePerPage);
          setTotalEntries(total);
          setTotalPage(totalPages);
        }
      },
      enabled: !!userDetail?.businessId,
    }
  );

  const handleChangeFilter = (key, value) => {
    setFilterDeposit((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleClearFilter = () => {
    setFilterDeposit({
      identity_number: "",
      name: "",
      phone_number: "",
      page: 0,
      size: sizePerPage,
    });
    setPage(0);
    setTimeout(() => {
      refetch();
    }, 200);
  };

  const handleClickFilter = () => {
    setPage(0);
    refetch();
  };

  const handlePagination = (value) => {
    setPage(value);
  };

  const handleChangeSizePerPage = (size) => {
    setPage(0);
    setSizePerPage(size);
    setFilterDeposit((prev) => ({
      ...prev,
      size: size,
    }));
  };

  return (
    <ListDepositComponents
      handleChangeFilter={handleChangeFilter}
      handleClearFilter={handleClearFilter}
      handleClickFilter={handleClickFilter}
      handlePagination={handlePagination}
      handleChangeSizePerPage={handleChangeSizePerPage}
      isLoading={isLoading || isFetching}
      filterDeposit={filterDeposit}
      dataPatientDeposit={dataPatientDeposit}
      activePage={page}
      totalPage={totalPage}
      totalEntries={totalEntries}
      sizePerPage={sizePerPage}
    />
  );
}
